<template>
  <div class="user-config">
    <el-popover placement="bottom" title="呼叫设置" trigger="click" width="340" @show="init">
      <ele-form
        :form-schema="schema"
        :form-data="formData"
        :isShowBackBtn="false"
        :isShowErrorNotify="false"
        label-position="right"
        :request-fn="submit"
        submitBtnText="保存"
        :form-attrs="{ size: 'small' }"
      >
        <template #lineSetting>
          <el-button type="text" @click="handleJump">设置</el-button>
        </template>
        <template #offLineSilent>
          <el-switch v-model="offLineSilent" @change="handleSwitch"></el-switch>
        </template>
      </ele-form>
      <el-button icon="el-icon-setting" slot="reference" type="text" size="normal">呼叫设置</el-button>
    </el-popover>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      schema: {},
      formData: {},
      offLineSilent: false
    }
  },
  computed: {
    ...mapState('callUserConfig', [
      'showRingingTime',
      'autoCallPostCallTime',
      'aiCallPostCallTime',
      'predictiveCallPostCallTime'
    ]),
    ...mapGetters('caller', ['HasAvayaNum', 'HasAgent', 'IsAiExtension', 'HasTrNum']),
    isRegionCallIn() {
      return this.$route.path.includes('/region-callin/')
    }
  },
  created() {
    // this.offLineSilent
    const data = window.localStorage.getItem('_crm_avaya_system_notify')
    this.offLineSilent = data === '1'
  },
  methods: {
    ...mapActions('callUserConfig', ['setCallUserConfig']),
    init() {
      this.generateSchema()
      this.formData = {
        showRingingTime: this.showRingingTime,
        autoCallPostCallTime: this.autoCallPostCallTime,
        aiCallPostCallTime: this.aiCallPostCallTime,
        predictiveCallPostCallTime: this.predictiveCallPostCallTime
      }
    },
    async submit(formData) {
      const oldData = {
        showRingingTime: this.showRingingTime,
        autoCallPostCallTime: this.autoCallPostCallTime,
        aiCallPostCallTime: this.aiCallPostCallTime,
        predictiveCallPostCallTime: this.predictiveCallPostCallTime
      }
      await this.setCallUserConfig(formData)

      this.$message.success('保存成功')
    },
    generateSchema() {
      this.schema = {
        offLineSilent: {
          label: '离线通知',
          // type: 'switch'
          vif: this.isRegionCallIn
        },
        lineSetting: {
          label: '线路码排序'
        },
        showRingingTime: {
          type: 'switch',
          label: '显示振铃时长',
          labelTip: '开启后，主动外呼时，模拟弹屏软电话条会展示振铃时长',
          vif: this.HasAgent
        },
        autoCallPostCallTime: {
          type: 'number-input',
          label: '自动外呼话后处理时长',
          required: true,
          vif: this.HasAgent,
          attrs: {
            min: 1,
            max: 300
          }
        },
        aiCallPostCallTime: {
          type: 'number-input',
          label: 'AI外呼话后处理时长',
          required: true,
          vif: this.IsAiExtension,
          attrs: {
            min: 0,
            max: 30
          }
        },
        predictiveCallPostCallTime: {
          type: 'number-input',
          label: '预测外呼话后处理时长',
          vif: this.HasTrNum,
          required: true,
          attrs: {
            min: 3,
            max: 300
          }
        }
      }
    },

    handleJump() {
      window.open(`${process.env.VUE_APP_AICALL_HOST}microweb/#/mw-callcenter-admin/line-manager/sort`)
    },

    handleSwitch(val) {
      window.localStorage.setItem('_crm_avaya_system_notify', val ? '1' : '0')
    }
  }
}
</script>

<style lang="stylus" scoped>
.user-config {
  /deep/ {
    .el-icon-setting {
      width: auto;
      height: auto;
      line-height: 1 !important;
      text-align: center;
      vertical-align: top !important;
    }
    .el-button--text {
      color: #424f6b !important
    }
  }
}
</style>
